"use strict";
exports.__esModule = true;
function rejectAfter(timeout, error) {
    return new Promise(function (resolve, reject) {
        setTimeout(function () {
            reject(error || new Error('Request timeout'));
        }, timeout);
    });
}
exports.rejectAfter = rejectAfter;
// tslint:disable-next-line:no-any
function cancelAfter(promise, timeout) {
    if (timeout === void 0) { timeout = 5000; }
    return Promise.race([promise, rejectAfter(timeout)]);
}
exports.cancelAfter = cancelAfter;
//# sourceMappingURL=promises.js.map